/**
 * User-facing API error display: never surfaces raw server `message`.
 * Mirrors listeReglement/invoices.vue: errorCode → i18n, else generic error.
 *
 * @param {import('vue').default} vm - component instance ($message, $t, $te)
 * @param {unknown} err - axios error or similar
 */
export function showApiError(vm, err) {
  const data = err && err.response && err.response.data
  const code = data && data.errorCode
  if (code) {
    const key = `errorCode.${code}`
    if (vm.$te(key)) {
      vm.$message.error(vm.$t(key))
      return
    }
  }
  if (!err || !err.response) {
    vm.$message.error(vm.$t('warning.connectionProblem'))
    return
  }
  vm.$message.error(vm.$t('error.erreur'))
}
